import CONFIG from "./../config.json";


function empOnClickLink(event, element) {
    event.preventDefault();

    var overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    overlay.style.backdropFilter = 'blur(10px)';
    overlay.style.zIndex = '999';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';

    var loadingImage = document.createElement('img');
    loadingImage.src = '../cartells_192.png';
    loadingImage.alt = 'Loading...';
    loadingImage.style.marginBottom = '20px';
    
    var linkImage = document.createElement('a');
    linkImage.href = 'https://cartells.elmolideponent.com';

    var link2 = document.createElement('a');
    link2.href = 'https://editor.elmolideponent.com';
    link2.innerText = 'editor.elmolideponent.com';
    link2.style.color = 'white';
    link2.style.textDecoration = 'none';
    link2.style.marginBottom = '10px';

    var link1 = document.createElement('a');
    link1.href = 'https://cartells.elmolideponent.com';
    link1.innerText = 'cartells.elmolideponent.com';
    link1.style.color = 'white';
    link1.style.textDecoration = 'none';
   
    linkImage.appendChild(loadingImage);
    overlay.appendChild(linkImage);
    overlay.appendChild(link2);
    overlay.appendChild(link1);

    document.body.appendChild(overlay);

    window.location.href = element.href;
}



function empEditorWakeUp()
{
    //
    try {
        fetch(`${CONFIG.posters_editor_url}/wakeup`);
    } catch (e) {

    }
}

export { empOnClickLink, empEditorWakeUp };


